<div class="queue-selection-form">
  @if (sortedQueueControls.length === 0) {
    <div class="state-message">
      <p>No enabled queues available at this time.</p>
    </div>
  } @else {
    @if (shouldShowSelect) {
      <ion-item lines="none">
        <ion-label>Select Queue</ion-label>
        <ion-select
          fill="outline"
          [(ngModel)]="selectedQueueId"
          [disabled]="isSubmitting || disabled"
          placeholder="Choose a queue"
          interface="popover"
          justify="end"
        >
          @for (queueControl of sortedQueueControls; track queueControl.id) {
            <ion-select-option [value]="queueControl.id">
              {{ queueControl.name }}
            </ion-select-option>
          }
        </ion-select>
      </ion-item>
    } @else if (shouldShowTiles) {
      <div class="queue-selection-tiles" role="radiogroup" aria-label="Select Queue">
        @for (queueControl of sortedQueueControls; track queueControl.id) {
          <button
            type="button"
            class="queue-selection-tile"
            [class.selected]="selectedQueueId === queueControl.id"
            [disabled]="isSubmitting || disabled"
            role="radio"
            [attr.aria-checked]="selectedQueueId === queueControl.id"
            (click)="onQueueItemClick(queueControl.id)"
          >
            <span class="queue-selection-tile-title">{{ queueControl.name }}</span>
            @if (queueControl.description) {
              <span class="queue-selection-tile-description">{{ queueControl.description }}</span>
            }
            <span class="queue-selection-tile-meta">
              @if (queueControl.capacity) {
                Capacity: {{ queueControl.capacity }}
              }
              @if (queueControl.status) {
                <span>Status: {{ queueControl.status }}</span>
              }
            </span>
          </button>
        }
      </div>
    } @else if (shouldShowRadio) {
      <ion-radio-group
        class="queue-selection-radio-group"
        [(ngModel)]="selectedQueueId"
        [disabled]="isSubmitting || disabled"
      >
        <crowdctrl-list class="queue-selection-list">
          @for (queueControl of sortedQueueControls; track queueControl.id) {
            <ion-item
              class="queue-selection-item"
              button
              (click)="onQueueItemClick(queueControl.id)"
              [disabled]="isSubmitting || disabled"
            >
              <ion-radio
                class="queue-selection-radio"
                [value]="queueControl.id"
                slot="start"
                [disabled]="isSubmitting || disabled"
              ></ion-radio>
              <ion-label>
                <h2>{{ queueControl.name }}</h2>
                @if (queueControl.description) {
                  <p>{{ queueControl.description }}</p>
                }
                @if (queueControl.capacity) {
                  <p class="queue-meta">Capacity: {{ queueControl.capacity }}</p>
                }
                @if (queueControl.status) {
                  <p class="queue-meta">Status: {{ queueControl.status }}</p>
                }
              </ion-label>
            </ion-item>
          }
        </crowdctrl-list>
      </ion-radio-group>
    }

    <div class="input-section">
      @if (inputMode === 'numeric') {
        <h2 class="input-label">{{ idLabel }}</h2>
        <div
          class="name-input-display"
          [class.has-content]="customerId && customerId.length > 0"
          [class.disabled]="isSubmitting || disabled"
        >
          <span class="name-text">{{ customerId || '' }}</span>
          @if (!isSubmitting && !disabled) {
            <span class="name-cursor">|</span>
          }
        </div>
        <crowdctrl-numeric-keyboard
          [value]="customerId"
          [minLength]="1"
          [maxLength]="12"
          [disabled]="isSubmitting || disabled"
          (valueChange)="onIdChange($event)"
        ></crowdctrl-numeric-keyboard>
      } @else {
        <h2 class="input-label">{{ nameLabel }}</h2>
        <div
          class="name-input-display"
          [class.has-content]="customerName && customerName.length > 0"
          [class.disabled]="isSubmitting || disabled"
        >
          <span class="name-text">{{ customerName || '' }}</span>
          @if (!isSubmitting && !disabled) {
            <span class="name-cursor">|</span>
          }
        </div>
        <crowdctrl-alphabetic-keyboard
          [value]="customerName"
          [maxLength]="18"
          [disabled]="isSubmitting || disabled"
          (valueChange)="onNameChange($event)"
        ></crowdctrl-alphabetic-keyboard>
      }
    </div>

    <div class="submit-section">
      <crowdctrl-loading-button
        expand="block"
        size="large"
        (pressed)="onSubmit()"
        [loading]="isSubmitting"
        [loadingText]="submitLoadingLabel"
        [disabled]="isSubmitDisabled"
      >
        {{ submitLabel }}
      </crowdctrl-loading-button>
    </div>
  }
</div>
